var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Types from '../../Types';
let i18nData = {};
const SIMPLE_PATTERN = /{([a-zA-Z0-91_.[\]]+)}/g;
export function init(language, loadI18n) {
    return __awaiter(this, void 0, void 0, function* () {
        const i18nDataForLanguage = yield loadI18n(language);
        if (i18nDataForLanguage) {
            i18nData = i18nDataForLanguage;
        }
        else {
            const i18nFallback = yield loadI18n(Types.Language.en);
            if (i18nFallback) {
                i18nData = i18nFallback;
            }
        }
    });
}
export function translate(bundle, key, replace) {
    const i18nBundle = i18nData[bundle];
    if (i18nBundle) {
        let translation = i18nBundle[encodeKey(key)];
        if (typeof translation === 'string') {
            if (replace) {
                return translation.replace(SIMPLE_PATTERN, (match, replaceKey) => {
                    return replace[replaceKey] || match;
                });
            }
            else {
                return translation;
            }
        }
    }
    return '';
}
export function encodeKey(key) {
    // Synced with rules in sheet script
    return key.replace(/(\/|#|\[|\]|\.|\$)/g, '-');
}
//# sourceMappingURL=index.js.map